import React from 'react';
import styled from 'styled-components';
import { ThemeProvider } from '../../../components-core/packages/components-core/dist/theme-provider';

//LAYOUT
import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerGutter,
    ContainerHorizontalAlignment
} from '../../../components-core/packages/components-core/dist/container';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { Layout } from '../../../components-core/packages/components-core/dist/layout';

//STYLE
import { Text, TextAppearance, TextColor } from '../../../components-core/packages/components-core/dist/text';
import { Accordion } from '../../../components-core/packages/components-core/dist/accordion';

//CUSTOM COMPONENTS
import ModelComparisonTable from './ModelComparisonTable';
import CustomAccordion from '../custom-accordion/CustomAccordion';


const BorderContainer = styled.div`
    border: 1px solid #dfe4e8;
`;

class ModelComparisonAccordion extends React.Component {

    constructor() {
        super();
        this.state = {
            isOpen: false
        }
    }

    render() {
        const { isOpen } = this.state;

        return (
            <Container padding={containerPadding} wrap={ContainerWrap.always}>
                <BorderContainer>
                    <Container stretchContent={true} >
                        <CustomAccordion 
                            backgroundColor={isOpen ? '#00437a' : '#FFF'} 
                            horizontalPadding={ContainerPadding.dynamic0150}
                            title={renderAccordionTitle(isOpen)} 
                            onClick={() => this.setState({ isOpen: !isOpen })}
                        >
                            <ModelComparisonTable cars={this.props.cars} />
                        </CustomAccordion>
                    </Container>
                </BorderContainer>
            </Container>
        )
    }
}


const renderAccordionTitle = (isOpen) => (
    <ThemeProvider theme={isOpen ? 'inverted' : 'main'} >
        <Text appearance={TextAppearance.headline0250} bold>Merhaba Dünya</Text>
    </ThemeProvider>
)

const containerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid001,
        [Breakpoints.b1600]: ContainerPadding.grid002
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid001,
        [Breakpoints.b1600]: ContainerPadding.grid002
    }
}

export default ModelComparisonAccordion;